import { IActivity } from '../../data-models';
import { useNewUploadFailures } from '../../hooks/use-new-upload-failures';
import { uploadCaseIdOf } from '../../utils/upload-activities';
import {
  StyledNotification,
  ToastNotificationGroupStyle,
} from '../base/simple-styled-components';

const TRY_AGAIN = 'Please try again.';

export const failureMessage = (failures: IActivity[]) => {
  if (failures.length === 1) {
    const [failure] = failures;
    const document = failure.docType
      ? `"${failure.docType}" document`
      : 'document';
    return `Sorry, we were unable to upload your ${document} for case ${uploadCaseIdOf(
      failure,
    )}. ${TRY_AGAIN}`;
  }

  const caseIds = [...new Set(failures.map(uploadCaseIdOf))];
  return `Sorry, we were unable to upload some of your documents for ${
    caseIds.length === 1 ? 'case' : 'cases'
  } ${caseIds.join(', ')}. ${TRY_AGAIN}`;
};

/**
 * Red toast for uploads that fail while it's mounted. Stays until closed.
 * Mount once for the logged in app so it shows on any page.
 */
export const UploadFailureToast = () => {
  const { newFailures, dismiss } = useNewUploadFailures();

  return (
    <div id="upload-failure-notification">
      <ToastNotificationGroupStyle
        style={{
          top: 16,
          right: 32,
          alignItems: 'flex-end',
          position: 'fixed',
          // above the sticky-top banner (1020), below modals (1050)
          zIndex: 1040,
        }}
      >
        {newFailures.length > 0 && (
          <StyledNotification
            key="upload-failure"
            type={{ style: 'error', icon: false }}
            closable={true}
            onClose={dismiss}
          >
            {failureMessage(newFailures)}
          </StyledNotification>
        )}
      </ToastNotificationGroupStyle>
    </div>
  );
};
